import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';
import { ScriptHitset } from './script-hitset';
import { ScriptArchivedSearch } from './script-archived-search';
import { SEARCH_HELP } from './search-archive$';

export class SearchArchiveItem {
    id: string;
    title: string;
    script: string;
    runScript: string;
    date: Temporal.ZonedDateTime;
    help?: SEARCH_HELP;

    constructor(
        private coords: CoordinatorService,
        {
            title,
            script,
            runScript,
            date,
            help,
        }: {
            title: string;
            script: string;
            runScript: string;
            date?: string;
            help?: SEARCH_HELP;
        },
    ) {
        this.id = this.coords.uniqueId();
        this.title = title;
        this.script = script;
        this.runScript = runScript;
        this.help = help;
        // console.log("SAVE - runScript", runScript);

        if (date) {
            this.date = Temporal.ZonedDateTime.from(date);
        } else {
            this.date = coords.utils$.zonedDateTimeNow;
        }
    }

    export() {
        const d: any = this.data;
        delete d.id;
        delete d.date;

        this.coords.filesystem$.saveFile2(
            'search.json',
            new Blob([JSON.stringify(d)], { type: 'application/json' }),
        );
    }

    run(isPreview = false) {
        const runS = `const dt = ${isPreview ? '$preview' : '$collection'};
        ${this.runScript}`;

        const respLs: ScriptHitset[] = this.coords.script$.run(runS);
        if (!respLs.length) return null;
        let finalHitset = respLs.pop()!;
        while (respLs.length) {
            finalHitset = finalHitset.and(respLs.pop()!);
        }

        return finalHitset;
    }

    apply() {
        this.coords.script$.run(this.script);
        this.coords.display$.closeDialog();
    }

    get data() {
        return {
            id: this.id,
            title: this.title,
            script: this.script,
            runScript: this.runScript,
            help: this.help,
            date: this.date.toString(),
        };
    }

    get deleteParams() {
        return {
            fun: () => this.coords.searchArchive$.delete(this),
            icon: 'delete',
        };
    }

    get scriptClass() {
        return new ScriptArchivedSearch(this.coords, this);
    }

    get helpHtml() {
        console.log('HELP', this.help);
        if (!this.help) return this.coords.text('NotAvailable');
        const ls: string[] = [];
        ls.push('<table>');
        this.help.fieldLs &&
            this.help.fieldLs.forEach((h) => {
                h.value &&
                    ls.push(
                        `<tr><td>${this.coords.text(h.tag)}</td><td>${h.value || ''}</td></tr>`,
                    );
            });
        this.help.filterLs &&
            this.help.filterLs.forEach((h) => {
                if (h.requiredLs?.length)
                    ls.push(
                        `<tr>
                            <td>${this.coords.text(h.tag)} - ${this.coords.text('required')}</td>
                            <td>${h.requiredLs.join('; ')}</td>
                        </tr>`,
                    );
                if (h.excludedLs?.length)
                    ls.push(
                        `<tr>
                            <td>${this.coords.text(h.tag)} - ${this.coords.text('excluded')}</td>
                            <td>${h.excludedLs.join('; ')}</td>
                        </tr>`,
                    );
                console.log('HHH', h);
            });
        ls.push('</table>');

        return ls.join('');
    }
}
